export const PaginationHelper = {
  getTotalRenderer: (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      รายการที่ {from} ถึง {to} จากทั้งหมด {size} รายการ
    </span>
  ),
}
